import React from 'react';
import AutomationRuleDetailSection from '../../../sections/AdminDashboard/Configuration/AutomationRuleDetail';

const AutomationRuleDetail = () => <AutomationRuleDetailSection />;

export default AutomationRuleDetail;
